<!-- <div class="flex flex-wrap justify-center gap-4">
<div class="w-full sm:w-1/2 lg:w-1/3" *ngFor="let tea of teas">
  <a [href]="tea.link">
    <img [src]="tea.image" [alt]="tea.name" class="w-full">
  </a>
</div>
</div> -->

<!-- <div class="container mx-auto px-4">
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
  <div class="w-full" *ngFor="let tea of teas">
    <a [href]="tea.link" class="flex justify-center">
      <img
        [src]="tea.image"
        [alt]="tea.name"
        class="w-full h-auto object-cover max-w-[400px] max-h-[400px]"
        >
    </a>
  </div>
</div>
</div> -->

<!-- <div class="grid grid-cols-1 -sm:grid-cols-2 -lg:grid-cols-2 gap-16 max-w-5xl mx-auto p-8">
<div *ngFor="let tea of teas" class="flex justify-center items-center">
  <a [href]="tea.link">
    <img
      [src]="tea.image"
      [alt]="tea.name"
      class="w-[350px] sm:w-[512px] h-auto -object-cover"
      >
  </a>
</div>
</div> -->

<div class="max-w-6xl mx-auto p-8">
  <div class="space-y-8">
    @for (tea of teas; track tea; let i = $index) {
      <div
        class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center relative">
        <!-- Image -->
        <div [ngClass]="{'md:order-2': i % 2 !== 0}"
          class="relative z-0">
          <a [href]="tea.link">
            <img [ngSrc]="(tea.image | imageModifier:{width:1400} | async) || ''"
              [alt]="tea.name"
              class="w-full max-w-[600px] sm:max-w-[700px] h-auto object-cover rounded-md drop-shadow-md"
              width="700"
              height="700">
          </a>
        </div>
        <!-- Tea Name -->
        @if (tea.name!=='Matcha') {
          <div class="absolute left-1/2 top-1/2 translate-x-[12%] -translate-y-1/2 md:static md:transform-none z-10 w-[40%] md:w-full py-8"
          [ngClass]="{
            'md:translate-x-1/2': i % 2 === 0,
             'md:-translate-x-1/2 md:text-right': i % 2 !== 0
           }">
            <a [href]="tea.link"
              class="inline-block px-4 py-8 rounded text-xs md:text-3xl hover:text-green-100 hover:bg-green-800 transition-colors drop-shadow-md w-full text-center font-[Castellar]"
              [style.color]="tea.textcolor"
              [style.backgroundColor]="tea.bgcolor"
              >
              {{tea.name}}
            </a>
          </div>
        }
        <!-- Tea Name - special for Matcha -->
        @if (tea.name==='Matcha') {
          <div class="absolute left-1/2 top-3/4 -translate-x-1/2 -translate-y-1/2 md:static md:transform-none z-10 w-[40%] md:w-full py-8"
          [ngClass]="{
            'md:translate-x-1/2': i % 2 === 0,
             'md:-translate-x-1/2 md:text-right': i % 2 !== 0
           }">
            <a [href]="tea.link"
              class="inline-block px-4 py-8 rounded text-xs md:text-3xl hover:text-green-100 hover:bg-green-800 transition-colors drop-shadow-md w-full text-center font-[Castellar]"
              [style.color]="tea.textcolor"
              [style.backgroundColor]="tea.bgcolor"
              >
              {{tea.name}}
            </a>
          </div>
        }
      </div>
    }
  </div>
</div>